<template>
  <h2>Edit {{ localUser.first_name }}'s details</h2>
  <form @submit.prevent="editUserDetails">
    <div class="form-group mb-3">
      <label for="firstName" class="form-label">First name</label>
      <input type="text" id="firstName" class="form-control" v-model="localUser.first_name"
             ref="userFirstNameInput" required>
      <div v-if="firstNameError" class="text-danger">{{ firstNameError }}</div>
    </div>
    <div class="form-group mb-3">
      <label for="lastName" class="form-label">Last name</label>
      <input type="text" id="lastName" class="form-control" v-model="localUser.last_name" required>
      <div v-if="lastNameError" class="text-danger">{{ lastNameError }}</div>
    </div>
    <div class="text-end">
      <button type="button" class="btn btn-secondary me-3" @click="cancel">Cancel</button>
      <button type="submit" class="btn btn-primary" :disabled="isSaveDisabled" @click="editDetails">Save</button>
    </div>
  </form>
</template>

<script>
import {API_BASE_URL} from "@/config";

export default {
  name: "EditUserDetails",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localUser: {...this.user},
    };
  },
  mounted() {
    this.$refs.userFirstNameInput.focus();
    window.addEventListener('keydown', this.handleKeydown);
  },
  emits: ['close'],
  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
    cancel() {
      this.$emit('close');
    },
    async editDetails() {
      try {
        const response = await fetch(`${API_BASE_URL}/users/${this.localUser.username}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify(this.localUser),
          credentials: 'include'
        });
        if (response.ok) {
          this.$emit('close');
        } else {
          console.error('Failed to update user details');
        }
      } catch (error) {
        console.error('Error updating user details:', error);
      }
    },
  },
  computed: {
    firstNameError() {
      return this.localUser.first_name.trim() === '' ? 'First name is required' : '';
    },
    lastNameError() {
      return this.localUser.last_name.trim() === '' ? 'Last name is required' : '';
    },
    isSaveDisabled() {
      return this.firstNameError !== '' || this.lastNameError !== '';
    }
  }
}

function getCSRFToken() {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return '';
}

</script>


